<div class="rating-holder">
  <div class="c-rating c-rating--regular" [attr.data-rating-value]="calculatedRating">
    <button>1</button>
    <button>2</button>
    <button>3</button>
    <button>4</button>
    <button>5</button>
  </div>
</div>
